import React from "react";
import DistributionsOptionsFormFields from "./DistributionsOptionsFormFields";
import DistributionAllocationMethodsFields from "./DistributionAllocationMethodsFields";
import FeesFields from "./FeesFields";
import { AddHierarchy, LoanDocumentCard } from "../../../components";

const RMDForm = (props) => {
  const { isSave, isEdit, fields } = props;

  return (
    <div>
      <DistributionsOptionsFormFields {...props} />
      <DistributionAllocationMethodsFields {...props} />
      <FeesFields {...props} />
      <LoanDocumentCard
        {...props}
        fields={fields}
        isEdit={isEdit}
        isSave={isSave}
        fieldArrayName={fields.withdrawalDocumentType}
      />

      <AddHierarchy {...props} />
    </div>
  );
};

export default RMDForm;
